import { Route } from "react-router-dom";
import { LoginPage } from ".";
import ForgetPasswordPage from "./ForgetPasswordPage";
import RegisterPage from "./register";
import ResetPasswordPage from "./ResetPasswordPage";
import VerifyEmailPage from "./VerifyEmailPage";
import React from "react";
import VerifyPhonePage from "./verify-phone";

export default 
        <Route path="/auth">
            <Route path="login" element={<LoginPage />} />
            <Route path="register" element={<RegisterPage />} />
            <Route path="verify-email" element={<VerifyEmailPage />} />
            <Route path="forget-password" element={<ForgetPasswordPage />} />
            <Route path="reset-password" element={<ResetPasswordPage />} />
            <Route path="verify-phone" element={<VerifyPhonePage />} />
        </Route>
        